exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// C:/Users/liliang/Desktop/HazqShortElves-DNLiuHe/node_modules/core-js/modules/_wks-ext.js
// module id = 95
// module chunks = 4